
import { useNavigate } from "react-router-dom";
import "../components/NavOptions.css";

const NotFound404 = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-container">
      <h1 className="error-code">404</h1>
      <p className="error-message">Oops ! Strona, której szukasz, nie istnieje</p>
      <button className="home-button" onClick={() => navigate("/")}>
        Wróć na stronę główną
      </button>
    </div>
  );
};

export default NotFound404;
